import React from 'react';

/**
 * P01 · Card "Curso recomendado" / "Tu siguiente paso" (mockup líneas 844-859).
 * Vista para usuarios `acceso` y `logros`. Portada 188px + badge de nivel
 * en cian claro + título + "por qué" + meta + CTA "Empezar curso" +
 * enlace "Ver el temario antes de empezar".
 */
export default function HomeRecommended({
  title,
  level,
  why,
  meta,
  thumbnail,
  onStart,
  onSyllabus,
  startLabel = 'Empezar curso',
  syllabusLabel = 'Ver el temario antes de empezar',
}) {
  return (
    <article
      className="bg-surface overflow-hidden"
      style={{
        border: '1px solid var(--color-line)',
        borderRadius: 18,
        marginBottom: 22,
        boxShadow: '0 2px 14px rgba(16, 28, 54, 0.05)',
        maxWidth: '62ch',
      }}
      data-slot="home-recommended"
    >
      <div
        className="relative flex items-center justify-center"
        style={{
          width: '100%',
          height: 188,
          background: thumbnail
            ? undefined
            : 'repeating-linear-gradient(118deg, rgba(16,28,54,.10) 0 13px, rgba(16,28,54,.03) 13px 26px), #E3E9F2',
        }}
      >
        {thumbnail ? (
          <img
            src={thumbnail}
            alt=""
            className="w-full h-full"
            style={{ objectFit: 'cover' }}
          />
        ) : (
          <span
            style={{
              fontFamily: 'ui-monospace, monospace',
              fontSize: 11,
              color: '#3C475E',
            }}
          >
            portada del curso
          </span>
        )}
      </div>
      <div style={{ padding: 16 }}>
        {level && (
          <div
            style={{
              display: 'inline-flex',
              fontSize: 11,
              fontWeight: 800,
              borderRadius: 999,
              padding: '4px 10px',
              background: '#E6F6FB',
              color: 'var(--color-secondary-strong)',
              marginBottom: 9,
            }}
          >
            {level}
          </div>
        )}
        <h3
          style={{
            fontSize: 20,
            fontWeight: 800,
            lineHeight: 1.25,
            marginBottom: 6,
            margin: 0,
          }}
        >
          {title}
        </h3>
        {why && (
          <p
            style={{
              fontSize: 15,
              lineHeight: 1.55,
              color: '#3C475E',
              fontWeight: 600,
              marginBottom: 8,
              marginTop: 6,
            }}
          >
            {why}
          </p>
        )}
        {meta && (
          <div
            className="text-ink-2"
            style={{ fontSize: 13, fontWeight: 700, marginBottom: 15 }}
          >
            {meta}
          </div>
        )}
        <button
          type="button"
          onClick={onStart}
          className="w-full flex items-center justify-center cursor-pointer"
          style={{
            gap: 10,
            minHeight: 56,
            border: 0,
            borderRadius: 12,
            background: 'var(--color-accent)',
            color: 'var(--color-ink)',
            fontSize: 17,
            fontWeight: 800,
          }}
        >
          {startLabel}
        </button>
        {onSyllabus && (
          <button
            type="button"
            onClick={onSyllabus}
            className="cursor-pointer"
            style={{
              display: 'block',
              width: '100%',
              marginTop: 8,
              minHeight: 48,
              border: 0,
              background: 'transparent',
              color: 'var(--color-ink)',
              fontSize: 15,
              fontWeight: 700,
            }}
          >
            {syllabusLabel}
          </button>
        )}
      </div>
    </article>
  );
}
